import { Context } from '@nuxt/types';
import PathModule from '~/store/path';

export default function(context: Context) {
    const path = context.container.get(PathModule);

    if (context.route.path.startsWith('/enrollment') && (!path.path || path.path === 'enroll')) {
        context.redirect('/');
    }
}
